import type { Question } from '@/questionnaire/types'
import httpClient from '@/utils/httpClient'

const fetchAll = async (templateId: string): Promise<Record<string, Question>> => {
  const response = await httpClient.get<Question[]>(`/v1/templates/${templateId}/questions`)
  const questions: Record<string, Question> = {}
  response.data.forEach(question => {
    questions[question.code || question.template_variable_code] = question
  })
  return questions
}
export { fetchAll }
